import { Injectable } from '@angular/core';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { BehaviorSubject, filter, from, interval, switchMap } from 'rxjs';
import {ToastService} from './toast';

const CHECK_INTERVAL = 1000 * 60 * 10;

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  readonly updateAvailable$ = new BehaviorSubject(false);

  constructor(
    private readonly swUpdate: SwUpdate,
    private readonly toast: ToastService,
    private readonly analytics: Analytics
  ) {
    this.swUpdate.versionUpdates
      .pipe(filter((update): update is VersionReadyEvent => update.type === 'VERSION_READY'))
      .subscribe((update) => {
        this.updateAvailable$.next(true);

        this.toast.show('An update is required', {ongoing: true});

        logEvent(this.analytics, 'update-prompt-auto-refresh', {
          currentVersion: update.currentVersion.hash,
          latestVersion: update.latestVersion.hash,
        });
        window.location.reload();
      });

    interval(CHECK_INTERVAL).pipe(switchMap(() => this.checkForUpdate())).subscribe({
      error: () => {}
    });
  }

  checkForUpdate() {
    return from(this.swUpdate.checkForUpdate());
  }
}
